import React, { useContext } from 'react';
import { CustomerServiceContext } from './CustomerServiceContext';
import { ISearchResult } from './ICustomerService';
import Link from './Link';
import RightChevron from './RightChevron';

export interface SearchResultItemProps {
  result: ISearchResult;
}

const SearchResultItem = ({ result }: SearchResultItemProps) => {
  const { setView, setUrlName } = useContext(CustomerServiceContext);

  return (
    <li key={result.UrlName} className="customer-service-faq__search-results__list-item">
      <Link
        className="customer-service-faq__search-results__list-item__title-and-summary"
        href={`/pages/customer-service/${result.UrlName}`}
        onClick={() => {
          setView('article');
          setUrlName(result.UrlName);
        }}
      >
        <h4
          dangerouslySetInnerHTML={{ __html: result.Title }}
          className="customer-service-faq__search-results__list-item__title-and-summary__title"
        />
        <p
          dangerouslySetInnerHTML={{ __html: result.Summary }}
          className="customer-service-faq__search-results__list-item__title-and-summary__summary"
        />
      </Link>
      <Link
        className="customer-service-faq__search-results__list-item__chevron-wrapper"
        href={`/pages/customer-service/${result.UrlName}`}
        tabIndex={-1}
        onClick={() => {
          setView('article');
          setUrlName(result.UrlName);
        }}
      >
        <RightChevron className="customer-service-faq__search-results__list-item__chevron-self" />
      </Link>
    </li>
  );
};

export default SearchResultItem;